// extracted by mini-css-extract-plugin
export default {"grid":"style_grid__SJyG3","gridContent":"style_gridContent__SkJZZ","goBack":"style_goBack__oKImM"};